import { buildApiUrl, tenantApiPrefix } from '../config';
import { getTenantIdFromStorage } from '../utils/onboardingLocalStorage';

/**
 * The sales desk: every lead the sales agents have touched, as one list.
 * Backend: routers/sales_desk.py, services/sales_desk/service.py.
 */

export type DeskStage = 'new' | 'talking' | 'documents' | 'quoting' | 'quoted' | 'ready' | 'bound';

export interface DeskRecord {
  agent: string;
  ref: string;
  stage_label: string;
  next: string;
  link: string;
  at: string | null;
}

export interface DeskLead {
  id: string;
  name: string;
  email: string | null;
  phone: string | null;
  state: string | null;
  owner: string | null;
  came_from: string;
  agents: string[];
  outside: string[];
  stage: DeskStage;
  stage_label: string;
  next: string;
  next_link: string;
  due_at: string | null;
  renews_on: string | null;
  renews_soon: boolean;
  best_carrier: string | null;
  best_price: number | null;
  first_seen: string | null;
  last_activity: string | null;
  steps: { at: string | null; text: string; agent: string }[];
  records: DeskRecord[];
}

export interface Desk {
  as_of: string;
  days: number;
  stages: { key: DeskStage; label: string }[];
  leads: DeskLead[];
}

export async function fetchDesk(days: number): Promise<Desk> {
  const tid = getTenantIdFromStorage();
  if (!tid) throw new Error('Not authenticated');
  const token = localStorage.getItem('klaris_jwt');
  const response = await fetch(buildApiUrl(`${tenantApiPrefix(tid)}/sales-desk/leads?days=${days}`), {
    headers: { 'Content-Type': 'application/json', ...(token && { Authorization: `Bearer ${token}` }) },
  });
  if (!response.ok) {
    const body = await response.json().catch(() => null);
    throw new Error(body?.detail || 'Could not load the sales desk');
  }
  return response.json();
}
